<script setup lang="ts">
import type { SelectTriggerProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { SelectIcon, SelectTrigger, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

import KeyboardArrowDown from '~icons/material-symbols-light/keyboard-arrow-down';

const props = defineProps<
	SelectTriggerProps & {
		class?: HTMLAttributes['class'];
		arrowClass?: HTMLAttributes['class'];
	}
>();

const delegatedProps = computed(() => {
	const { class: _, arrowClass: _arrowClass, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
const isMounted = ref(false);

onMounted(() => {
	isMounted.value = true;
});
</script>

<template>
	<ClientOnly>
		<SelectTrigger
			v-show="isMounted"
			v-bind="forwardedProps"
			:class="
				cn(
					'flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-start text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate',
					props.class
				)
			"
		>
			<slot></slot>
			<SelectIcon as-child>
				<KeyboardArrowDown
					:class="cn('h-5 w-5 shrink-0 text-beige', arrowClass)"
				/>
			</SelectIcon>
		</SelectTrigger>
		<template #fallback>
			<div
				:class="
					cn(
						'flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-start text-sm shadow-sm ring-offset-background placeholder:text-muted-foreground focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-50 [&>span]:truncate',
						props.class
					)
				"
			>
				<slot></slot>
				<SelectIcon as-child>
					<KeyboardArrowDown
						:class="cn('h-5 w-5 shrink-0 text-beige', arrowClass)"
					/>
				</SelectIcon>
			</div>
		</template>
	</ClientOnly>
</template>
